import { render, staticRenderFns } from "./OrderDetailRoute.vue?vue&type=template&id=7d2e2d3a"
import script from "./OrderDetailRoute.vue?vue&type=script&lang=ts"
export * from "./OrderDetailRoute.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports